import { Methods } from "@newview/infrastructure";
import {NewviewWebsiteBaseApi} from "./NewviewWebsiteBaseApi";


export class WebsiteDevelopmentHistoryApi extends NewviewWebsiteBaseApi {

  public get ControllerName(): any {
    return 'website-development-history'
  }


}